var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('img',{staticClass:"logo",attrs:{"src":"https://storage.googleapis.com/visual-identity/logo/2020-slim.svg","alt":"Logo HEIG-VD","height":"80"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }